import { Howl } from "howler";

import { ReactComponent as Img1 } from "../assets/images/svg/001-dragon-29.svg";
import { ReactComponent as Img2 } from "../assets/images/svg/002-dragon-28.svg";
import { ReactComponent as Img3 } from "../assets/images/svg/003-dragon-27.svg";
import { ReactComponent as Img4 } from "../assets/images/svg/004-dragon-26.svg";
import { ReactComponent as Img5 } from "../assets/images/svg/005-dragon-25.svg";
import { ReactComponent as Img6 } from "../assets/images/svg/006-dragon-24.svg";
import { ReactComponent as Img7 } from "../assets/images/svg/007-dragon-23.svg";
import { ReactComponent as Img8 } from "../assets/images/svg/008-dragon-22.svg";
import { ReactComponent as Img9 } from "../assets/images/svg/009-dragon-21.svg";
import { ReactComponent as Img10 } from "../assets/images/svg/010-dragon-20.svg";
import { ReactComponent as Img11 } from "../assets/images/svg/011-dragon-19.svg";
import { ReactComponent as Img12 } from "../assets/images/svg/012-dragon-18.svg";
import { ReactComponent as Img13 } from "../assets/images/svg/013-dragon-17.svg";
import { ReactComponent as Img14 } from "../assets/images/svg/014-dragon-16.svg";
import { ReactComponent as Img15 } from "../assets/images/svg/015-dragon-15.svg";
import { ReactComponent as Img16 } from "../assets/images/svg/016-dragon-14.svg";
import { ReactComponent as Img17 } from "../assets/images/svg/017-dragon-13.svg";
import { ReactComponent as Img18 } from "../assets/images/svg/018-dragon-12.svg";
import { ReactComponent as Img19 } from "../assets/images/svg/019-dragon-11.svg";
import { ReactComponent as Img20 } from "../assets/images/svg/020-dragon-10.svg";
import { ReactComponent as Img21 } from "../assets/images/svg/021-dragon-9.svg";
import { ReactComponent as Img22 } from "../assets/images/svg/022-dragon-8.svg";
import { ReactComponent as Img23 } from "../assets/images/svg/023-dragon-7.svg";
import { ReactComponent as Img24 } from "../assets/images/svg/024-dragon-6.svg";
import { ReactComponent as Img25 } from "../assets/images/svg/025-dragon-5.svg";
import { ReactComponent as Img26 } from "../assets/images/svg/026-dragon-4.svg";
import { ReactComponent as Img27 } from "../assets/images/svg/027-dragon-3.svg";
import { ReactComponent as Img28 } from "../assets/images/svg/028-dragon-2.svg";
import { ReactComponent as Img29 } from "../assets/images/svg/029-dragon-1.svg";
import { ReactComponent as Img30 } from "../assets/images/svg/030-dragon.svg";

import clickSound from "../assets/sounds/card_click_fantasy2.wav";
import sound3 from "../assets/sounds/background.wav";
import winSound from "../assets/sounds/winpopup.wav";
import findSound from "../assets/sounds/find.wav";

export const allImages = [
	Img1,
	Img2,
	Img3,
	Img4,
	Img5,
	Img6,
	Img7,
	Img8,
	Img9,
	Img10,
	Img11,
	Img12,
	Img13,
	Img14,
	Img15,
	Img16,
	Img17,
	Img18,
	Img19,
	Img20,
	Img21,
	Img22,
	Img23,
	Img24,
	Img25,
	Img26,
	Img27,
	Img28,
	Img29,
	Img30,
];

export const mode2List = [
	{
		label: <span>6</span>,
		value: "6",
	},
	{
		label: <span>12</span>,
		value: "12",
	},
	{
		label: <span>20</span>,
		value: "20",
	},
	{
		label: <span>24</span>,
		value: "24",
	},
	{
		label: <span>30</span>,
		value: "30",
	},
	{
		label: <span>36</span>,
		value: "36",
	},
];
export const mode3List = [
	{
		label: <span>9</span>,
		value: "9",
	},
	{
		label: <span>12</span>,
		value: "12",
	},
	{
		label: <span>15</span>,
		value: "15",
	},
	{
		label: <span>24</span>,
		value: "24",
	},
	{
		label: <span>30</span>,
		value: "30",
	},
	{
		label: <span>36</span>,
		value: "36",
	},
];

export const initGame = (mode, count) => {
	let obj = { rowCount: 3, colCount: 4, selectedImagesLength: 4 };
	switch (mode) {
		case "6": {
			obj = { rowCount: 3, colCount: 2, selectedImagesLength: 3 };
			break;
		}
		case "9": {
			obj = { rowCount: 3, colCount: 3, selectedImagesLength: 3 };
			break;
		}
		case "12": {
			obj = { rowCount: 4, colCount: 3, selectedImagesLength: 12 / +count };
			break;
		}
		case "15": {
			obj = { rowCount: 5, colCount: 3, selectedImagesLength: 5 };
			break;
		}
		case "20": {
			obj = { rowCount: 5, colCount: 4, selectedImagesLength: 10 };
			break;
		}
		case "24": {
			obj = { rowCount: 6, colCount: 4, selectedImagesLength: 24 / +count };
			break;
		}
		case "30": {
			obj = { rowCount: 6, colCount: 5, selectedImagesLength: 30 / +count };
			break;
		}
		case "36": {
			obj = { rowCount: 6, colCount: 6, selectedImagesLength: 36 / +count };
			break;
		}
	}

	const imgs = allImages
		.sort(() => (Math.random() < 0.5 ? -1 : 1))
		.slice(0, obj.selectedImagesLength)
		.map((Icon, index) => ({ Icon, typeId: index + 1 }));

	let myImages = [...imgs, ...imgs, ...(count === "2" ? [] : imgs)];

	const list = [];
	for (let i = 0; i < +obj.rowCount; i++) {
		const row = [];

		for (let j = 0; j < +obj.colCount; j++) {
			const index = Math.floor(Math.random() * myImages.length);

			row.push({ id: `${i}_${j}`, ...myImages[index] });
			myImages.splice(index, 1);
		}
		list.push(row);
	}

	return list;
};

const backgroundSound = new Howl({
	src: [sound3],
	loop: true,
	volume: 0.15,
});

const settingsSound = new Howl({
	src: [clickSound],
});

const youWinSound = new Howl({
	src: [winSound],
});

const smallWin = new Howl({
	src: [findSound],
});

export const sounds = {
	settingsSound,
	backgroundPlay: backgroundSound,
	youWinPlay: youWinSound,
	smallWin,
};

export const threeModeActiveTime = 3 * 24 * 60 * 60 * 1000; // First number is Day count

export const initThreeMode = () => {
	const activetTime = window.localStorage.getItem("threeMode");
	if (!activetTime) return false;

	const currentTime = Date.now();
	if (currentTime - Number(activetTime) > threeModeActiveTime) {
		window.localStorage.removeItem("threeMode");
		return false;
	}

	window.localStorage.setItem("threeMode", Date.now());
	return true;
};
